module.exports = __webpack_public_path__ + "static/media/online-reserv.33867286.png";